import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import WorkCard from "../work-card/WorkCard";
import { experience } from "../../data/experience";
import { staggerContainer } from "../../animations/variants";
import { usePrefersReducedMotion } from "../../hooks/usePrefersReducedMotion";
import "./Experience.css";

function Experience() {
  const { t } = useTranslation();
  const prefersReducedMotion = usePrefersReducedMotion();
  const container = prefersReducedMotion ? {} : staggerContainer(0.12);

  return (
    <section id="experience" className="experience">
      <div className="section-inner">
        <h2 className="section-title">{t("experience.sectionTitle")}</h2>
        <motion.div
          className="experience-timeline"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={container}
        >
          {experience.map((entry) => (
            <WorkCard key={entry.id} entry={entry} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Experience;
